module.exports = __webpack_public_path__ + "static/media/timer.1a3cc3f1.svg";